/**
 * Owner: Masa Bayu
 * File: guards.ts
 * Date:Time: 2026-09-14 20:33
 * Description: Primitive guards for QXP core contracts.
 */
export const VERSION_PATTERN = /^\d+\.\d+\.\d+$/;
export const TIMESTAMP_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
export function assertValidId(id, label) {
    if (typeof id !== 'string' || id.length === 0 || /\s/.test(id)) {
        throw new Error(`${label} must be a non-empty id without whitespace`);
    }
}
export function assertOptionalTrimmed(value, label) {
    if (value === undefined || value === null) {
        return null;
    }
    if (typeof value !== 'string' || value.trim().length === 0) {
        throw new Error(`${label} must be a non-empty string`);
    }
    return value.trim();
}
export function assertOrder(value, label) {
    if (typeof value !== 'number' || !Number.isInteger(value) || value < 0) {
        throw new Error(`${label} must be a non-negative integer`);
    }
}
//# sourceMappingURL=guards.js.map